import axiosInstance from "./AxiosInstance";

export function getDashboardDataApi() {
  return axiosInstance.get("/api/dashboard");
}

export function getAssetCategoryDistributionApi() {
  return axiosInstance.get("/api/dashboard/asset-category-distribution/");
}

// 3. Monthly trend for asset creation (area chart)
export function getAssetTrendApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`/api/dashboard/asset-trend/?${fparam}`);
}

// 4. Status-wise asset distribution (pie/bar)
export function getStatusDistribution() {
  return axiosInstance.get("/api/dashboard/status-distribution/");
}

export function getTopDepartments() {
  return axiosInstance.get("/api/dashboard/top-departments/");
}

export function getMaintenanceCostApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`/api/dashboard/maintenance-trend/?${fparam}`);
}

export function getDisposedApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`/api/dashboard/disposed-trend/?${fparam}`);
}

export function getWarrantyExpiryCountApi() {
  return axiosInstance.get("/api/dashboard/warranty-expiry/");
}

// 9. Audit-related summary statistics

export function getRequestMomentApi(data) {
  return axiosInstance.get("api/asset-movement-requests", { params: data });
}
export function updateRequestMomentDetailsApi(requestId, data) {
  return axiosInstance.patch(`/api/asset-movement-requests/${requestId}`, data);
}

export function getAssetAlertsApi(params = {}) {
  return axiosInstance.get("/api/dashboard/asset-alert/", {
    params: {
      ...params,
      timestamp: new Date().getTime() // Cache busting
    }
  });
}

export function getAssetTotalCostApi() {
  return axiosInstance.get("/api/dashboard/assets/cost-summary/");
}

export function getMaintenanceCostCostApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`/api/dashboard/assets/maintenance-cost/?${fparam}`);
}

export function getReturnRequestApi() {
  return axiosInstance.get("/api/dashboard/store-manager/requests/");
}

export function getMoveRequestApi() {
  return axiosInstance.get("/api/dashboard/location-manager/requests/");
}

export function getHodDashboardDataApi() {
  return axiosInstance.get("/api/dashboard/hod-dashboard/");
}
export function getAuditorDashboardDataApi() {
  return axiosInstance.get("/api/dashboard/auditor-dashboard/");
}